module.exports = __webpack_public_path__ + "first-50_paper.jpg?5e69099cf264791d4e225a86ec09324b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/first-50_paper.jpg
// module id = 572
// module chunks = 0